import { Space } from 'antd';
import styled from 'styled-components';

export const AdvancedSearchMultipleItemWrapper = styled(Space.Compact)`
  > .ant-form-item {
    flex: 1;
    margin-right: -1px;
    margin-left: -1px;
  }
`;
